import { getCurrentEnvironment } from "../../../constants/api";
import { SPSDrive } from "../../../constants/constants";

/**
 * return Site ID
 * @returns 
 */
const getSiteId = () => {
	const env = getCurrentEnvironment();
	if (env.environment == "prod") {
		return "789fe9f1-cee1-49b1-8b17-9620e5589ea2,b15f9832-736c-4067-9b20-712f898000ba";
	} else {
		return "d97f38ac-5e13-4f47-8d7d-461cd71c2f88,b15f9832-736c-4067-9b20-712f898000ba";
	}
};

const siteId = getSiteId();

/**
 * environment folder IDs
 */
const env_folder_id = {	
	dev: "b!rDh_2RNeR0-NfUYc1xwviDKYX7Fsc2dAmyBxL4mAALrQnABNThC3RpxlYDSrrWSY",
	test: "b!rDh_2RNeR0-NfUYc1xwviDKYX7Fsc2dAmyBxL4mAALq7feRVwggmRK1gQFdSGmUB",
	stage: "b!rDh_2RNeR0-NfUYc1xwviDKYX7Fsc2dAmyBxL4mAALrtSo2nLAEIT6yUpF1YITD-",
	prod: "b!8emfeOHOsUmLF5Yg5VieojKYX7Fsc2dAmyBxL4mAALrGHMzNWWEwRblysxDyaPj7"
};

/**
 * environment folder Names
 */
const env_folder_name = {
	dev: "Datacenter-Portal-Dev",
	test: "Datacenter-Portal-Test",
	stage: "Datacenter-Portal-Stage",
	prod: "Datacenter-Portal-Prod"
};

/**
 * Instance ids
 */
const env_abrf_id = {
	dev: "8a0d7ff7-0f31-411d-a529-73a79a99fac2",
	test: "ba600fea-b405-400d-888d-3071e80d51c0",
	stage: "b1ec971a-3069-439b-a17c-01e807304cc5",
	prod: "2b952c13-d705-44a3-8b53-0377037272dc"
};

/**
 * Environment site folder
 * @param {*} idObjName - environment folder id
 * @returns 
 */
function getEnvSiteFolder(idObjName = env_folder_id) {

	// if (window.location.href.indexOf("https://streamdatum-dc") >= 0 || window.location.href.indexOf("operationsportal") >= 0	) {
	if (window.location.href.indexOf("app-ui-dcopl-prd-eus") >= 0 || window.location.href.indexOf("https://dcop.stream-dc") >= 0	) {
		return idObjName["prod"];
	} else if (window.location.href.indexOf("app-ui-dcopl-stg-eus") > 0 || window.location.href.indexOf("stage-dcop.stream-dc") >= 0) {
		return idObjName["stage"];
	} else if (window.location.href.indexOf("app-ui-dcopl-tst-eus") > 0 || window.location.href.indexOf("test-dcop.stream-dc") >= 0) {
		return idObjName["test"];
	} else if (window.location.href.indexOf("localhost") > 0) {
		return idObjName["dev"];
	} else if (window.location.href.indexOf("app-ui-dcopl-dev-eus") > 0 || window.location.href.indexOf("dev-dcop.stream-dc") >= 0) {
		return idObjName["dev"];
	}

	return idObjName["dev"];

}
 

/**
 * returns Share point driveId
 * @param {*} PropertyKey 
 * @returns 
 */
function getDriveId(PropertyKey) {
	try {
		if (SPSDrive && SPSDrive.value) {
			return SPSDrive.value.filter(data => {
				return data.name == PropertyKey;
			})[0].id;
		}
	} catch (e) { /* empty */ }
}

/**
 * returns share point URL depends upon conditions.
 * @param {*} name - name
 * @param {*} folderName - folder name
 * @param {*} fileName - file name
 * @param {*} domain - domain
 * @returns 
 */
export function getSharepointUrl(
	name = "getSps",
	folderName = "",
	fileName = "",
) {
	switch (name) {
		case "getSps":
			return `https://graph.microsoft.com/v1.0/sites/${siteId}/lists`;

		case "getSpsByFolder":
			return `https://graph.microsoft.com/v1.0/sites/${siteId}/drives/${getEnvSiteFolder()}/root/children/${folderName}/children`;

		case "createFolder":
			return `https://graph.microsoft.com/v1.0/sites/${siteId}/drives/${getEnvSiteFolder()}/root/children`;

		case "getInnerFolder":
			return `https://graph.microsoft.com/v1.0/sites/${siteId}/drives/${getEnvSiteFolder()}/root/children/${folderName}/`;

		case "getChildItem":
			return `https://graph.microsoft.com/v1.0/sites/${siteId}/lists/${folderName}/drive/root/children?expand=listItem($expand=fields)`;

		case "uploadFile":
			return `https://graph.microsoft.com/v1.0/sites/${siteId}/lists/${getEnvSiteFolder()}/drive/root:/${fileName}:/content?expand=listItem($expand=fields)`;

		case "uploadMetadata":
			// Here fileName is a itemId
			return `https://graph.microsoft.com/v1.0/sites/${siteId}/lists/${folderName}/items/${fileName}/fields`;

		case "uploadFileSession":
			return `https://graph.microsoft.com/v1.0/sites/${siteId}/lists/${getEnvSiteFolder(
				env_folder_name
			)}/drive/root:/${folderName}/${fileName}:/createUploadSession`;

		case "deleteFile":
			// Here fileName is a itemId
			return `https://graph.microsoft.com/v1.0/sites/${siteId}/lists/${folderName}/items/${fileName}`;

		case "getDriveList":
			// Here fileName is a itemId
			return `https://graph.microsoft.com/v1.0/sites/${siteId}/drives`;

		case "deleteFileByDrive":
			return `https://graph.microsoft.com/v1.0/sites/${siteId}/drives/${getDriveId(
				folderName
			)}/root:/${fileName}`;

		case "aboutUsDetails":
			return `https://graph.microsoft.com/v1.0/sites/${siteId}/lists/About/Items?expand=listItem($expand=fields)`;

		case "updateItems":
			return `https://graph.microsoft.com/v1.0/sites/${siteId}/lists/${getEnvSiteFolder(
				env_abrf_id
			)}/items`;
	}
}
